import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouteService } from '../../../../core/services/route.service';
import { map } from 'rxjs/operators';
import { AuthService } from '@wm-libs/core';
import { StorageService } from '@wm-libs/core';
import { UserService } from '@wm-libs/core';
import { Subscription } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import { NgClass, AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-verify-tfa',
  templateUrl: './verify-tfa.component.html',
  styleUrls: ['../../styles/auth.scss'],
  standalone: true,
  imports: [NgClass, MatCardModule, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, AsyncPipe, TranslateModule],
})
export class VerifyTfaComponent implements OnDestroy {
  private needTfa$: Subscription;

  isMobile$ = this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small]).pipe(map((result) => result.matches));

  tfaCode!: string;
  tfaForm!: FormGroup;
  tfaCodeRequestFailed = false;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private routeService: RouteService,
    private userService: UserService,
    private storageService: StorageService,
    private breakpointObserver: BreakpointObserver
  ) {
    const token = this.storageService.getToken() || '';

    if (!token) {
      this.routeService.goToLogin();
    }

    this.needTfa$ = this.userService.needTfa$.subscribe((needTfa) => {
      if (!needTfa) {
        this.routeService.goToLogin();
      }
    });

    this.tfaForm = this.fb.group({
      tfaCode: ['', [Validators.required]],
    });

    this.tfaForm.valueChanges.subscribe(() => {
      this.tfaCodeRequestFailed = false;

      if (this.tfaForm.valid) {
        this.verifyTfa();
      }
    });
  }

  verifyTfa(): void {
    this.authService.enableTfa(this.tfaForm.value.tfaCode).subscribe(
      (res) => {
        this.userService.setAuthenticated(true);

        this.userService.setUserData(res);
        this.routeService.goToMain();
      },
      () => {
        this.tfaForm.reset();
        this.tfaCodeRequestFailed = true;
      }
    );
  }

  logOut() {
    this.authService.logout().subscribe(() => {
      this.storageService.removeToken();
      this.userService.setAuthenticated(false);
      this.userService.setNeedTfa(false);
      this.routeService.goToLogin();
    });
  }

  ngOnDestroy(): void {
    if (this.needTfa$) this.needTfa$.unsubscribe();
  }
}
